import React, { useState } from 'react';
import { StarIcon } from 'lucide-react';
export const ReviewForm = () => {
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');
  return <div className="border-t border-gray-100 pt-6 mt-6" data-id="element-356">
      <h3 className="text-lg font-medium mb-4" data-id="element-357">Write a Review</h3>
      <div className="space-y-4" data-id="element-358">
        <div data-id="element-359">
          <p className="text-sm text-gray-600 mb-2" data-id="element-360">Rating</p>
          <div className="flex space-x-1" data-id="element-361">
            {[1, 2, 3, 4, 5].map(star => <button key={star} onClick={() => setRating(star)} className="focus:outline-none" data-id="element-362">
                <StarIcon className={`h-6 w-6 ${star <= rating ? 'text-amber-400 fill-amber-400' : 'text-gray-300'}`} data-id="element-363" />
              </button>)}
          </div>
        </div>
        <div data-id="element-364">
          <p className="text-sm text-gray-600 mb-2" data-id="element-365">Your Review</p>
          <textarea value={comment} onChange={e => setComment(e.target.value)} className="w-full border border-gray-200 rounded-md p-3 h-32 focus:outline-none focus:ring-2 focus:ring-indigo-500" placeholder="Share your experience with this app..." data-id="element-366" />
        </div>
        <button className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700 transition-colors" data-id="element-367">
          Submit Review
        </button>
      </div>
    </div>;
};